module.exports = require("react-split-pane");


//////////////////
// WEBPACK FOOTER
// external "react-split-pane"
// module id = 588
// module chunks = 0